module.exports = __webpack_public_path__ + "img/11 PORTRAIT.6c27d9eb.png";